/* CNC MARKET ROOT — every storefront fetch must carry the market prefix.

   WHY THIS EXISTS. Measured on the live site 2026-09-23, twice, in two identical
   fresh sessions opened on the SAME /en-au/ product page:

     fetch('/cart/add.js')                    -> cart USD 4499   (the US price)
     fetch(routes.root + 'cart/add.js')       -> cart AUD 6499   (correct)

   A path beginning with "/" resolves against the host root, so it drops the
   market subfolder and Shopify answers as the PRIMARY market. The whole cart
   session is then pinned to USD — /en-au/cart.js afterwards still returned USD.
   An Australian shopper adding through cross-sell, the slide cart or quick-add
   direct-add ended up in a US-dollar cart at the US price.

   Same effect on product JSON:
     fetch('/products/terrasen-sweatshirt.js')      -> 4499
     fetch(root + 'products/terrasen-sweatshirt.js') -> 6499

   Shopify names this exact trap: "If you've hardcoded a URL like /cart in a link
   or Ajax request, then visitors browsing in another language or market context
   will be forced back to the domain defaults. This means they might see the wrong
   language or currency." (shopify.dev, About Shopify Markets.)

   window.Shopify.routes.root is set by Shopify per market context — "/en-au/" on
   the AU subfolder, "/" on the primary market and on any market that has its own
   domain. So cncUrl() is correct before and after the .com.au move, and on every
   other market that stays on a subfolder (UK, CA, EU, International). */

window.cncUrl = function (path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  return root + String(path).replace(/^\/+/, '');
};
